import { useFeatureFlagState } from "@vericus/cadmus-common";

import { useHomeOutletContext } from "./home-page";
import { Preparation } from "./preparation";
import { StudentHome } from "./student-home";

/**
 * The `/home` index tab. With `student_home` off it renders `Preparation`,
 * exactly what shipped before this feature, so a flag-off tenant is unaffected
 * by this work; with the flag on it renders `StudentHome`. `HomeRoute` blocks
 * until the flag resolves (see its note there), so `enabled` is already settled
 * here and the tab paints its final page with no Preparation-to-Home flip.
 */
export function HomeIndex() {
  const { enabled } = useFeatureFlagState("student_home");
  const feed = useHomeOutletContext();

  return enabled ? <StudentHome {...feed} /> : <Preparation />;
}
